export default __webpack_public_path__ + "static/media/logo-saga.21b8d878.png";